import React from "react";
import Brand from "./Brand";

// Splits a plain string on the canonical brand token `CrewZNatioN` and
// returns a React fragment where every occurrence is replaced with the
// semantically bold <Brand /> component. Any node that is not a string
// (React element, array, etc.) is returned unchanged. Any string that
// does not contain the token is returned as-is. Use to wrap editorial
// text passed as strings via data structures (e.g. rules arrays, media
// captions, collapsible titles) so the brand token renders in bold
// without altering the surrounding editorial wording.
export default function BrandText({ children }) {
    if (typeof children !== "string") return children;
    const parts = children.split("CrewZNatioN");
    if (parts.length === 1) return children;
    return (
        <>
            {parts.map((part, i) => (
                <React.Fragment key={i}>
                    {part}
                    {i < parts.length - 1 && <Brand />}
                </React.Fragment>
            ))}
        </>
    );
}
